var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", [
      _c("thead", [
        !_vm.tableHeader
          ? _c("tr", [
              _c("th", { staticStyle: { width: "15%" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("uppercase")(_vm.$t("date"))) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("th", { staticStyle: { width: "17%" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("uppercase")(_vm.$t("actionBy"))) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("th", [
                _vm._v(
                  _vm._s(
                    _vm._f("uppercase")(_vm.$t("tenancy.history.category"))
                  )
                ),
              ]),
              _vm._v(" "),
              _c("th", { staticStyle: { width: "42%" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm._f("uppercase")(_vm.$t("tenancy.history.value"))
                    ) +
                    "\n        "
                ),
              ]),
            ])
          : _c(
              "tr",
              _vm._l(_vm.tableHeader, function (head) {
                return _c("th", { key: head, style: { width: head.width } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("uppercase")(head.title)) +
                      "\n        "
                  ),
                ])
              }),
              0
            ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "table-content" }, [
      _c("table", [
        _c(
          "tbody",
          [
            !_vm.tableHeader
              ? _vm._l(_vm.orderHistories, function (item, index) {
                  return _c("tr", { key: index }, [
                    _c("td", { staticStyle: { width: "15%" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm._f("formatDate")(
                              item.createdAt,
                              "DD MMM YY HH:mm:ss"
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { width: "17%" } }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(item.who.displayName) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm.contactCategoryTranslate(item.detail)
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticStyle: { width: "42%" } },
                      [_c("loopComponent", { attrs: { data: item.values } })],
                      1
                    ),
                  ])
                })
              : _vm._l(_vm.orderHistories, function (item, index) {
                  return _c(
                    "tr",
                    { key: index },
                    _vm._l(_vm.tableHeader, function (head) {
                      return _c("td", { key: head }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.getItemProperty(item, head.name)) +
                            "\n            "
                        ),
                      ])
                    }),
                    0
                  )
                }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }